import { OnInit, OnDestroy, Directive } from '@angular/core';

@Directive({
  standalone: true,
})
export class DialogWrapperComponent implements OnInit, OnDestroy {
  ngOnInit() {
    document.body.style.top = '-' + window.pageYOffset + 'px';
    document.body.classList.add('modal-opened');
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-opened');
    if (document.body.style.top) {
      const top = document.body.style.top.match(/\d+/g).map(Number)[0];
      window.scrollTo(0, top);
    }
    document.body.style.removeProperty('top');
  }
}
